import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

declare var $: any;

@Component({
    selector: 'app-nps-survey',
    templateUrl: './nps-survey.component.html',
    styleUrls: ['./nps-survey.component.scss']
})
export class NpsSurveyComponent implements OnInit {
    safeURL; //youTube Video URL //

    constructor(
        private meta: Meta, 
        private title: Title, 
        private _sanitizer: DomSanitizer,
        private metaService: MetaServiceService) {
        //  SEO Meta Description
        this.meta.addTags([
            { name: 'description', content: 'The Net Promoter Score Survey is a questionnaire designed to help businesses understand what their customers think about our products and services.' },
            { name: 'author', content: 'CViewSurvey' },
            { 
              name: 'keywords',
              content: 'Net Promoter Score , Net Promoter Score questions , customer satisfaction survey form,  Calculate your NPS , customer satisfaction survey template , customer satisfaction survey benefits , Customer satisfaction survey b2b , Survey templates' ,  },
        ]);

        this.setTitle('Net Promoter Score Survey | Customer Satisfaction survey');
        // End SEO Meta Description


        // You Tube Video Description
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/O5rgp4xbB88?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
        // End You Tube Video Description

    }


    // SEO Page Title Description
    public setTitle(newTitle: string) {
        this.title.setTitle(newTitle);
    }
    // SEO Page Title Description


    ngOnInit() {
        // for create canonical link 
        this.metaService.createCanonicalURL();
        // Tab Content Hover Show/Hide
        $(document).ready(function () {
            $(".tab-titles li").hover(function () {
                $(".tab-content").hide();
                $(".tab-titles li").removeClass('active');
                $(this).addClass("active");
                var selected_tab = $(this).find("a").attr("data-id");
                $(selected_tab).stop().fadeIn();
                return true;
            });
        });
        // End Tab Content Hover Show/Hide
    }

}
